import { useState, useMemo } from 'react'
import {
  Box,
  Slider,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  TextField
} from '@mui/material'

const TIERS = [
  { cap: 1000, price: 4 },
  { cap: 5000, price: 17.5 },
  { cap: 10000, price: 30 },
  { cap: 50000, price: 125 },
  { cap: 100000, price: 200 },
  { cap: 250000, price: 375 },
  { cap: 500000, price: 625 },
  { cap: 1000000, price: 1000 }
]

function calcPrice (credits, period = 'monthly') {
  const tier = TIERS.find(t => credits <= t.cap) || TIERS.at(-1)
  const rate = tier.price / tier.cap
  let total = +(credits * rate).toFixed(2)

  if (period === 'yearly') total = +(total * 12 * 0.8).toFixed(2)
  return total
}

export default function AddCreditsSlider ({ onPriceChange }) {
  const [credits, setCredits] = useState(1000)
  const [period, setPeriod] = useState('monthly')
  const price = useMemo(() => calcPrice(credits, period), [credits, period])

  const marks = [
    { value: 1000, label: '1K' },
    { value: 100000, label: '100K' },
    { value: 500000, label: '500K' },
    { value: 1000000, label: '1M' }
  ]

  async function handlePurchase () {
    onPriceChange({ credits, period, price })
  }

  return (
    <Box p={3}>
      <Typography variant='h6' gutterBottom>
        Add Email Verification Credits
      </Typography>

      {/* Billing toggle */}
      <ToggleButtonGroup
        value={period}
        exclusive
        onChange={(_, v) => v && setPeriod(v)}
        sx={{ mb: 3 }}
        size='small'
      >
        <ToggleButton value='monthly'>Monthly</ToggleButton>
        <ToggleButton value='yearly'>Yearly</ToggleButton>
      </ToggleButtonGroup>

      {/* Slider */}
      <Slider
        aria-label='Credits'
        value={credits}
        min={1000}
        max={1000000}
        step={1000}
        marks={marks}
        valueLabelDisplay='auto'
        valueLabelFormat={v => v.toLocaleString('en-US')}
        onChange={(_, v) => setCredits(v)}
      />

      {/* Optional manual input */}
      <TextField
        type='number'
        inputProps={{ step: 1000, min: 1000, max: 1000000 }}
        label='Credits'
        value={credits}
        onChange={e => setCredits(Math.min(1000000, Math.max(1000, Number(e.target.value))))}
        sx={{ mt: 2 }}
        fullWidth
      />

      {/* Price read‑out */}
      <Typography variant='subtitle1' sx={{ mt: 2 }}>
        {credits.toLocaleString()} credits &nbsp;→&nbsp;
        <strong>${price.toLocaleString()}</strong> {period === 'yearly' ? 'per year' : 'this month'}
      </Typography>

      <Button
        variant='contained'
        color='primary'
        fullWidth
        sx={{ mt: 3 }}
        onClick={handlePurchase}
      >
        Add Credits &amp; Continue
      </Button>
    </Box>
  )
}
